'use strict';

angular.module('cimerFrontEndApp').controller('SurveyPreviewCtrl', ['$scope', '$routeParams', 'SurveyService', '$location', 'Session', 'authorized', function ($scope, $routeParams, SurveyService, $location, Session, authorized) {
    // If the user isn't authorized to view this survey, route away
    if (!authorized) {
        $location.url('/');
        return;
    }

    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated) {
        $location.url('/');
        return;
    }
    
        $scope.surveyId = 0;
        if ($routeParams.surveyId) {
            var value = parseInt($routeParams.surveyId, 10);
            if (!isNaN(value)) {
                $scope.surveyId = value;
            } else {
                $location.path('error');
                return;
            }
        } else {
            $location.path('error');
            return;
        }
       
        $scope.survey = [];

        SurveyService.getSurvey($scope.surveyId).then(function (result) {

            $scope.survey = result;
        }, function (err) {
            $location.path('error');
        });

    $scope.printSurvey = function () {
        window.print();
    };

    }]);
